import { Provider } from 'mobx-react';
import * as React from 'react';
import { ContentMap } from './ContentMap';
import { ContentMapStore } from './store/ContentMapStore';
import { IInstance } from '../../interfaces/IInstance';
import { Helper } from '../../Helper';
import { configure } from 'mobx';
import { IFontSlots } from '../../interfaces/IFontSlots';
const PACKAGE = require("../../../package.json");

export interface IAContentMapProps {
  tenant: string;
  environment: "Development" | "Test" | "Production";
  token: string;
  instance: IInstance;
  highlightColor: string;
  isMobile: boolean;
  hasDarkBackground: boolean;
  styles?: React.CSSProperties;
  inEditMode?: boolean;
  returnPageUrl?: boolean;
  openAllLinksExternally?: boolean;
  isExtension?: boolean;
  fontSlots?: IFontSlots;
  onClick: () => void;
  showPage?: (page: string) => void;
}

export interface IAContentMapState {
  hasChanged: string;
}

export class IAContentMap extends React.Component<IAContentMapProps, IAContentMapState> {

  private contentMapStore: ContentMapStore;

  constructor(props: IAContentMapProps) {
    super(props);
    this.state = {
      hasChanged: Helper.getRandomStringKey()
    }
    this.contentMapStore = new ContentMapStore();
    configure({
      isolateGlobalState: true,
      enforceActions: "never"
    });
    this.updateProperties(props);
  }

  public componentDidMount(): void {
    console.log(`%c Content map is running IntraActive SDK-UI version: ${PACKAGE?.version}`, 'background: #1c899d; color: #ffffff');
  }

  public componentWillReceiveProps(props: IAContentMapProps): void {
    this.updateProperties(props);
  }

  private updateProperties(props: IAContentMapProps): void {
    this.contentMapStore.setEnvironment(props.environment);
    this.contentMapStore.setTenant(props.tenant);
    this.contentMapStore.setToken(props.token);
    this.contentMapStore.setInstance(props.instance);
    this.contentMapStore.setHighlightColor(props.highlightColor);
    this.contentMapStore.setIsMobile(props.isMobile);
    this.contentMapStore.setHasDarkBackground(props.hasDarkBackground);
    this.contentMapStore.setStyles(props.styles);
    this.contentMapStore.setInEditMode(props.inEditMode);
    this.contentMapStore.setReturnPageUrl(props.returnPageUrl);
    this.contentMapStore.setOpenAllLinksExternally(props.openAllLinksExternally);
    this.contentMapStore.isExtension = props.isExtension;
    this.contentMapStore.fontSlots = props.fontSlots;
    this.setState({ hasChanged: Helper.getRandomStringKey() });
  }

  public render(): JSX.Element {
    return (
      <Provider contentMapStore={this.contentMapStore}>
        <ContentMap
          hasChanged={this.state.hasChanged}
          onClick={() => this.props.onClick()}
          showPage={(page: string) => this.props.showPage(page)}
        />
      </Provider>
    )
  }
}
